export default "__VITE_ASSET__b5dc89df__"